import { combineReducers } from '@reduxjs/toolkit';
import { libraryDocumentsOverviewReducers } from './overview/OverviewReducers';

export const libraryDocumentsReducers = combineReducers({
	overview: libraryDocumentsOverviewReducers
});